// CreateMacro.jsx
import React from "react";
import PageLayout from '../../Components/PageLayout';
import "../../Css/CreateMacro.css";

function CreateMacro() {
    return (
        <PageLayout title="Create Macro" subtitle="Create Macro overview">
            <div className="container flex col box-container">
            <div className="navbar">
      <div className="navbar-left">
        <div className="nav-item">Strona główna</div>
        <div className="nav-item">Produkty</div>
        <div className="nav-item">O nas</div>
        <div className="nav-item">Kontakt</div>
        <div className="nav-item">Blog</div>
        <div className="nav-item">Kariera</div>
        {/* Możesz dać tyle itemów ile chcesz */}
      </div>
      <div className="navbar-right">
        <span className="username">Jan Kowalski</span>
        <button className="logout-btn">Wyloguj</button>
      </div>
    </div>
            </div>
        </PageLayout>   
    );
}

export default CreateMacro;
